import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress, SelectChangeEvent } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketPriorityInfo } from '../../../../state';
import { useGetTicketUrgenciesQuery } from '../../../../../../services/DimensionService/dimensionApi';

const UrgencyEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);
  const { data: urgencies, isLoading, error } = useGetTicketUrgenciesQuery();

  const handleChange = (event: SelectChangeEvent) => {
    dispatch(updateTicketPriorityInfo({ urgency: event.target.value }));
  };

  return (
    <FormControl size="small" fullWidth>
      <InputLabel>Urgency</InputLabel>
      <Select
        value={currentTicket?.priorityInfo.urgency || ''}
        onChange={handleChange}
        label="Urgency"
        disabled={isLoading || !!error}
      >
        {isLoading ? (
          <MenuItem disabled>
            <CircularProgress size={20} sx={{ mr: 1 }} />
            Loading urgencies...
          </MenuItem>
        ) : error ? (
          <MenuItem disabled>Error loading urgencies</MenuItem>
        ) : (
          urgencies?.map((urgency) => (
            <MenuItem key={urgency.value} value={urgency.value}>
              {urgency.name}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};

export default UrgencyEdit;
